import "core-js/modules/es.array.includes.js";
import { Card as MuiCard } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
var StyledCard = styled(MuiCard).withConfig({
  shouldForwardProp: function shouldForwardProp(propName) {
    return !['ml', 'mr', 'mb', 'mt', 'p'].includes(propName);
  }
})(function (props) {
  return {
    '&&': {
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: typeof props.p === 'string' && props.p === 'sm' ? '16px' : '24px',
      marginLeft: typeof props.ml === 'number' ? props.theme.spacing(props.ml) : undefined,
      marginRight: typeof props.mr === 'number' ? props.theme.spacing(props.mr) : undefined,
      marginBottom: typeof props.mb === 'number' ? props.theme.spacing(props.mb) : undefined,
      marginTop: typeof props.mt === 'number' ? props.theme.spacing(props.mt) : undefined
    }
  };
});
export function Card(_ref) {
  var children = _ref.children,
    ml = _ref.ml,
    mr = _ref.mr,
    mt = _ref.mt,
    mb = _ref.mb,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(StyledCard, {
    variant: "outlined",
    ml: ml,
    mr: mr,
    mt: mt,
    mb: mb,
    p: size
  }, children);
}